import React from 'react';
import { HandArrow } from './Hand';
import { useTilt } from '../hooks/useTilt';

export function StatTile({
    label,
    value,
    unit,
    sub,
    doodle,
    className = '',
}: {
    label: string;
    value: string;
    unit?: string;
    sub?: string;
    /* A hand doodle above the label, for tiles that carry the section's picture. */
    doodle?: React.ReactNode;
    className?: string;
}) {
    const tilt = useTilt<HTMLDivElement>({ max: 4 });

    return (
        <div
            ref={tilt.ref}
            onPointerMove={tilt.onPointerMove}
            onPointerLeave={tilt.onPointerLeave}
            className={['ds-stat', 'ds-glass', 'ds-glass--3d', 'ds-glass--r-xl', className].filter(Boolean).join(' ')}
        >
            {doodle && <span className="ds-stat__doodle">{doodle}</span>}
            <span className="ds-stat__label">{label}</span>
            <div className="ds-stat__row">
                <span className="ds-stat__value">{value}</span>
                {unit && <span className="ds-stat__unit">{unit}</span>}
                <span className="ds-stat__arrow" aria-hidden="true">
                    <HandArrow width={28} />
                </span>
            </div>
            {sub && <p className="ds-stat__sub">{sub}</p>}
        </div>
    );
}
